import { render, staticRenderFns } from "./ProductCustomersAndSuppliers.vue?vue&type=template&id=3794186a&scoped=true&lang=pug&"
import script from "./ProductCustomersAndSuppliers.vue?vue&type=script&lang=ts&"
export * from "./ProductCustomersAndSuppliers.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCustomersAndSuppliers.vue?vue&type=style&index=0&id=3794186a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3794186a",
  null
  
)

export default component.exports